import { Link, Route, Routes } from "react-router-dom";
import wallpaper from "../../assets/wallpaper.jpg";
import { Header } from "../../header/Header";
import "./Home.css";
import individualImg from "../../assets/individual.jpg";
import childImg from "../../assets/child.jpg";
import coupleImg from "../../assets/couple.jpg";
import CounsellingCard from "./CounsellingCard";
import { AboutFounder } from "./AboutFounder";
import { Testimonials } from "./Testimonials";
import { Doubt } from "../aboutus/Doubt";
import { Footer } from "../footer/Footer";

export const Home = () => {
  return (
    <>
          <Header/>
    <div className="app-container" style={{ backgroundImage: `url(${wallpaper})` }}>

      <div>
        <h1 className="wecare">
          We Care For Your <br /> Happiness!!!
        </h1>
      </div>
      <div className="homebuttons">
      
      {/* Internal navigation */}
      <Link to="/contact" className="homebtn">GETTING STARTED</Link>

      {/* External link opens in new tab */}
      <a  href="https://forms.gle/your-google-form-id" className="homebtn" target="_blank" rel="noopener noreferrer">TAKE A QUICK QUIZ</a>
      
      </div>
    </div>
    
    <div className="counselling-card-container">
      <CounsellingCard
        imageSrc= {individualImg}
        title="Individual Therapy"
        description="A one-on-one process where a trained mental health professional helps an individual explore their thoughts, feelings"
        buttonText="TAKE ME THERE"
        linkTo="/services/individual"
        backgroundColor="#0f5fc2"
        textColor="#0f5fc2"
        textColorTitle ="#ffffff"
      />
      <CounsellingCard
        imageSrc={childImg}
        title="Child Therapy"
        description="A specialized form of therapy that provides emotional and psychological support to children and adolescents"
        buttonText="TAKE ME THERE"
        linkTo="/services/child"
        backgroundColor="#ffffff"
        textColor="#0f5fc2"
        textColorTitle ="#0f5fc2"
      />
      <CounsellingCard
        imageSrc={coupleImg}
        title="Couple Therapy"
        description="A form of psychotherapy that helps couples improve their relationship, resolve conflicts, and strengthen their bond"
        buttonText="TAKE ME THERE"
        linkTo="/services/couple"
        backgroundColor="#0f5fc2"
        textColor="#0f5fc2"
        textColorTitle ="#ffffff"
      />
    </div>
    <AboutFounder />
    <Testimonials />
    <Doubt />
    <Footer />
    </>
  );
};
